module.exports = __webpack_public_path__ + "img/king.bd50df84.svg";